import { Injectable } from '@angular/core'
import { ApiClient, ApiClientFactory, CustomHttpParameterCodec, serializeHttpParams } from '@ftr/api-shared'
import { ApiResult } from '@ftr/foundation'

@Injectable({
  providedIn: 'root',
})
export class AuthProxyService {
  private readonly apiClient: ApiClient

  constructor(apiClientFactory: ApiClientFactory) {
    this.apiClient = apiClientFactory.build('/auth-proxy')
  }

  /**
   * Revokes a refresh token.
   */
  revokeRefreshToken(Token: string, ClientId: string): ApiResult {
    return this.apiClient.post<null>({
      body: serializeHttpParams({
        Token,
        ClientId,
      }),
      headers: {
        'Content-Type': 'application/x-amz-json-1.1',
        'X-Amz-Target': 'AWSCognitoIdentityProviderService.RevokeToken',
      },
      encoder: new CustomHttpParameterCodec(),
    })
  }
}
